import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import theme from '../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class MergeWarningDialog extends Component
{

render() {

    return (

      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="Merge Warning"
       open={this.props.open}>
              <DialogContent>
              <div style={{padding: "5px 5px 5px 5px"}}>
              <Typography variant="h5" component="h5">
              <b>Warning</b>
              </Typography>
              <p>This will invalidate the existing data record, and tie its source to the specified parent record. The merged incident will be removed from the InFORM dataset and will not appear directly in map services or downloads.</p>

              <p>This operation <u>cannot be undone</u>.</p>

              <p>Are you sure you want to continue?</p>
              </div>

              </DialogContent>
       <DialogActions>
        <Button onClick={this.props.onRequestClose} color="primary">
          No, Cancel
        </Button>
          <Button onClick={this.props.mergeRecordConfirmed} color="primary">
            Yes, Merge record
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default MergeWarningDialog;
